export interface RouteConfig {
  path?: string; // Make path optional for wrapper components
  component?: string; // Component name as string for lazy loading
  children?: RouteConfig[];
  protected?: boolean;
  layout?: boolean;
  isRedirector?: boolean; // Special flag for Redirector component
  isNotFound?: boolean; // Special flag for catch-all route
  requiresNetwork?: boolean; // Flag to wrap route with network guard
}

// Type for valid component names - helps with type safety
export type ComponentName =
  | "LazyLogin"
  | "LazySSOCallback"
  | "LazyHome"
  | "LazyBuilder"
  | "LazySectionPreview"
  | "LazyAppLayout"
  | "LazyProtectedRoute"
  | "LazyNetworkGuard"
  | "RedirectToInteractive";

export const routesConfig: RouteConfig[] = [
  {
    path: "/redirect",
    isRedirector: true,
  },
  {
    path: "/login",
    component: "LazyLogin",
  },
  {
    path: "/sso-callback",
    component: "LazySSOCallback",
  },
  {
    path: ":surveyId/interactive",
    component: "RedirectToInteractive",
  },
  {
    path: ":surveyId/interactive/*",
    component: "RedirectToInteractive",
  },
  {
    path: "/",
    protected: true,
    layout: true,
    children: [
      {
        path: "/",
        component: "LazyHome",
        requiresNetwork: true,
      },
      {
        path: ":surveyId/builder",
        component: "LazyBuilder",
        requiresNetwork: true,
      },
      {
        path: "/innerapp/:surveyId/builder",
        component: "LazyBuilder",
        requiresNetwork: true,
      },
      {
        path: "/:surveyId/preview/:section",
        component: "LazySectionPreview",
      },
      {
        path: "/:surveyId/preview/:section/:propertyId",
        component: "LazySectionPreview",
      },
      {
        path: "/:id/preview/:section/:propertyId/floorPlanImage/:index",
        component: "LazySectionPreview",
      },
      // Catch-all route - must be last
      {
        path: "*",
        isNotFound: true,
      },
    ],
  },
];
